import { render, staticRenderFns } from "./bottomLeft4.vue?vue&type=template&id=080e4184&scoped=true&"
import script from "./bottomLeft4.vue?vue&type=script&lang=js&"
export * from "./bottomLeft4.vue?vue&type=script&lang=js&"
import style0 from "./bottomLeft4.vue?vue&type=style&index=0&id=080e4184&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080e4184",
  null
  
)

export default component.exports